// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9SZ65","label":"styles_label__nRyT-","items":"styles_items__CBoxc"};